import { alpha, Box, CircularProgress, Stack, Typography, useColorScheme } from "@mui/material";
import moment from "moment";
import { Constants } from "../../utils/constants";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import PendingButton from "../buttons/pending_button";
import { DefaultButton, ErrorButton } from "..";

export default function UserPendingItemWidget({ user, currentUserRole, resendInvite, cancelUser, isLoading }) {
    const { mode } = useColorScheme();

    const currentMode = mode || "system";
    return (
        <Stack key={user.user_id}
            direction={{
                xs: "column",
                sm: "row",
            }}
            alignItems={{
                xs: "start",
                sm: "center",
            }}
            justifyContent={"space-between"}
            sx={{
                padding: {
                    xs: `calc(${Constants.Styles.spacing} * 2)`,
                    sm: `calc(${Constants.Styles.spacing} * 4)`,
                },
                backgroundColor: alpha(Constants.Colors[currentMode].secondary, 0.3),
                border: `1px solid ${Constants.Colors[currentMode].border}`,
                borderRadius: `calc(${Constants.Styles.radius.base} - 2px)`,
            }}
            spacing={1}
        >

            <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                sx={{
                    // width: "100%",
                    // marginInline: "auto",
                }}
                spacing={"1.125rem"}
            >
                <Box
                    sx={{
                        borderRadius: "50%",
                        height: 40,
                        width: 40,
                        backgroundColor: alpha(Constants.Colors[currentMode].secondary, 1),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Typography
                        sx={{
                            color: Constants.Colors[currentMode].mutedForeground,
                            fontWeight: Constants.Styles.fontWeight.medium,
                            fontSize: Constants.Styles.fontSize.sm,
                            lineHeight: Constants.Styles.lineHeight.sm,
                        }}
                    >
                        {"?"}
                    </Typography>
                </Box>
                <Box>
                    <Typography sx={{
                        fontWeight: Constants.Styles.fontWeight.medium,
                        fontSize: Constants.Styles.fontSize.sm,
                        lineHeight: Constants.Styles.lineHeight.sm,
                    }}>
                        {user.user_id}
                    </Typography>
                    <Typography sx={{
                        fontWeight: Constants.Styles.fontWeight.normal,
                        fontSize: Constants.Styles.fontSize.xs,
                        lineHeight: Constants.Styles.lineHeight.xs,
                    }}>
                        {user.updated_at && moment(user.updated_at).fromNow()}
                    </Typography>
                </Box>
            </Stack>
            {isLoading && <CircularProgress size={24} />}
            {!isLoading && <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"start"}
                spacing={"0.5rem"}
            >
                <PendingButton />
                <DefaultButton
                    text={"Resend Invite"}
                    disabled={currentUserRole === "guest"}
                    size="small"
                    onClick={() => {
                        resendInvite(user);
                    }}
                    preIcon={<RefreshOutlinedIcon />}
                    sx={{
                        border: "none",
                        minWidth: {
                            xs: 130,
                            sm: 140,
                        },
                    }}
                />
                <ErrorButton
                    text={"Cancel"}
                    size="small"
                    disabled={currentUserRole === "guest"}
                    onClick={() => {
                        cancelUser(user);
                    }}
                    sx={{
                        border: "none",
                    }}
                />
            </Stack>}
        </Stack>
    );
}